var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSkills(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 208,
    viewBox: "0 0 263 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 189C25.6667 182.667 55.7 170.6 74.5 173C98 176 140 178 153.5 181.5C161.833 178.667 181.7 173 194.5 173C210.5 173 229 178 232.5 181.5C232.833 180 239 176.6 261 175",
    stroke: "#FB7C51",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.704 106.01C218.911 123.088 207.684 136.508 195.048 144.41C182.411 152.311 168.399 154.678 155.976 149.736C143.554 144.795 134.996 133.45 131.24 119.027C127.484 104.605 128.543 87.1404 135.336 70.0626C142.129 52.9849 153.356 39.5647 165.992 31.6633C178.629 23.7617 192.642 21.3949 205.064 26.3364C217.486 31.2778 226.044 42.6228 229.8 57.0455C233.557 71.4678 232.497 88.9324 225.704 106.01Z",
    stroke: "#FB7C51",
    strokeOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.804 102.072C210.475 115.467 201.683 125.994 191.798 132.194C181.913 138.395 170.969 140.253 161.282 136.399C151.594 132.545 144.917 123.678 141.992 112.382C139.067 101.086 139.908 87.396 145.236 74.0009C150.565 60.6059 159.357 50.0791 169.242 43.8786C179.127 37.6779 190.071 35.82 199.758 39.6737C209.446 43.5274 216.123 52.3943 219.048 63.6909C221.973 74.987 221.132 88.6768 215.804 102.072Z",
    stroke: "#FB7C51",
    strokeOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.328 98.3026C202.339 108.332 195.713 116.192 188.249 120.801C180.784 125.411 172.513 126.756 165.176 123.837C157.839 120.919 152.752 114.26 150.493 105.783C148.235 97.3052 148.818 87.042 152.808 77.0128C156.798 66.9836 163.423 59.1237 170.887 54.514C178.352 49.9044 186.623 48.5596 193.96 51.4782C201.297 54.3967 206.384 61.0555 208.643 69.5328C210.901 78.0102 210.318 88.2734 206.328 98.3026Z",
    stroke: "#FB7C51",
    strokeOpacity: 0.9
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.081,
    cy: 87.6735,
    rx: 14.8025,
    ry: 19.4259,
    transform: "rotate(21.6922 180.081 87.6735)",
    fill: "#FB7C51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.148 152.765C191.803 163.467 225.256 144.22 239.034 109.585C252.875 74.7897 241.617 37.6413 213.889 26.6113C207.602 24.1105 201.008 23.167 194.409 23.6089L194.168 24.6362C200.738 24.1515 207.293 25.0636 213.519 27.5405C240.549 38.2925 251.824 74.7254 238.105 109.215C224.426 143.601 191.364 162.325 164.379 151.781L164.148 152.765Z",
    fill: "#FB7C51",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 145.855L130 178.855H140L156.5 149.855",
    stroke: "#FB7C51",
    strokeOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.026 135.645L247.265 175.679L237.233 177.458L213.931 142.319",
    stroke: "#FB7C51",
    strokeOpacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 186.244L203 149.5C201.485 150.173 197.859 151.767 195.477 152.76L206.229 186.244L214.5 186.244Z",
    fill: "white",
    stroke: "#FB7C51",
    strokeOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9143 127.405L53.3644 140.259L39.7936 135.152L37.8823 127.454L45.9143 127.405Z",
    fill: "#FB7C51"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6229 124.759L37.8823 127.454M112.848 189.456L53.3644 140.259M53.3644 140.259L45.9143 127.405L37.8823 127.454M53.3644 140.259L37.8823 127.454M53.3644 140.259L39.7936 135.152L37.8823 127.454",
    stroke: "#FB7C51",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSkills);
export default __webpack_public_path__ + "static/media/noSkills.4c1abc947dab14ecb9f2f80fd27953d4.svg";
export { ForwardRef as ReactComponent };